//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AssemblyComponentName",1,0],[0,"CreateKinematicComponent",1,0],[0,"ExportMotion",1,0],[0,"ImportMotion",1,0],[0,"LinearCurveType",1,0],[0,"LinearMotionVector",1,"Direction",0],[1,"MotionBody",0,"SelectDisplayableObjectList",0],[0,"MotionName",1,0],[0,"MotionType",1,0],[0,"MoveDistance",1,0],[0,"PressStartAngle",1,0],[0,"PressStopAngle",1,0],[0,"ReturnStartAngle",1,0],[0,"ReturnStopAngle",1,0],[0,"RotaryCurveType",1,0],[0,"RotaryMotionAxis",1,"Axis",0],[0,"RotationAngle",1,0],[0,"UseControlData",1,0]],[[["motionName"],"DeleteUserDefinedMotion",{},1,0]],[]];
SPLM.Tooling.UserDefinedMotionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.UserDefinedMotionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.UserDefinedMotionBuilder.MotionTypes = Object.freeze({
    "Linear" : "Linear", "Rotary" : "Rotary"});

SPLM.Tooling.UserDefinedMotionBuilder.LinearCurveTypes = Object.freeze({
    "Linear" : "Linear", "FromFile" : "FromFile"});

SPLM.Tooling.UserDefinedMotionBuilder.RotaryCurveTypes = Object.freeze({
    "Rotary" : "Rotary", "FromFile" : "FromFile"});

export default SPLM;